import * as React from 'react';

import FileVideo16 from './FileVideo16';

export const fileVideo16 = () => <FileVideo16 />;

export default {
    title: 'Icon|Fill|FileVideo16',
    component: FileVideo16,
    parameters: {
        notes: "`import FileVideo16 from 'box-ui-elements/es/icon/fill/FileVideo16';`",
    },
};
